<template>
  <div class="dashboard-empty">
    <img src="/img/empty.svg" alt="Empty" height="80" />
    <p>Please click on the button below to load the <span v-if="section">{{ section }}</span> stats</p>
    <ElButton type="primary" size="small" :disabled="disabled" @click="$emit('initialize')">Load Data</ElButton>
  </div>
</template>

<script>
import {Button } from "element-ui";
export default {
  name: "DashboardEmpty",
  components: {
    ElButton: Button
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    section: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button--primary,
.el-button--primary:focus,
.el-button--primary:active,
.el-button--primary:hover {
  background-color: #4caf50;
  border-color: #4caf50;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  background-color: #4caf50;
  border-color: #4caf50;
  opacity: 0.5;
}

.dashboard-empty {
  text-align: center;
  width: 100%;

  img {
    height: 80px;
    width: auto;
  }
}
</style>
